import localizationService from "@/_services/localization-service";
import settingsService from "@/_services/settings-service";

export default {
  data: () => ({
    company: settingsService.get("applicationName"),
    contact: "Contact Us",
    local: "English",
    localizationPairs: [],
    pageName: "",   // To be set by the component using this mixin
  }),

  created() {
  },

  mounted() {
    this.load();
  },

  methods: {
    get(id) {
      var text = "undefined";
      var pair = this.localizationPairs.find(p => p.id == id);
      if(pair != null) {
        text = pair.text;
      }

      return text;
    },

    load(){
      this.localizationPairs = localizationService.get(this.pageName);
      this.getLocalization();
      this.company = this.get("company");
      this.contact = this.get("contact");
      this.local = this.get("local)");
    },
  },

  watch: {
    "$store.state.localization"() {
      this.load();
    },
  }

}